<template>
  <div
    class="h-100 flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="logo flex">
        <a href="/" class="router-link-active">
          <img src="https://static.triple-a.io/assets/images/TripleA-main-logo-transparent.png" alt="logo" class />
        </a>
        <!--<span class="logo-text" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>-->
      </div>

      <div class="signUp">
        <div v-if="signUpEmail" class="signUpEmailMsg">
          <span
            >Your credentials have been sent to {{ this.signUpEmail }} ! The
            email should arrive any moment now.</span
          >
        </div>
        <!-- FUTURE USE CASE -->
        <!-- <vs-button v-if="!$store.state.isSignUp" class="signUpBtn" color="#ffffff" text-color="#0a5692" @click="signUp()">New to TripleA ? Click to <strong>Sign up</strong></vs-button>
        <vs-button v-else class="signUpBtn" color="#ffffff" text-color="#0a5692" @click="signUp()">Click here to <strong>Login</strong> if you have account</vs-button>-->

        <!--        <vs-button-->
        <!--          v-if="!signUpEmail"-->
        <!--          class="signUpBtn"-->
        <!--          color="#ffffff"-->
        <!--          text-color="#0a5692"-->
        <!--        >-->
        <!--          <a-->
        <!--            href="mailto:support@triple-a.io?bcc=kohzhihao@triple-a.io&subject=Request for TripleA dashboard login"-->
        <!--          >Don't have an account yet? Contact us at <strong>support@triple-a.io</strong></a>-->
        <!--        </vs-button>-->
      </div>
      <div>
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <!--            <div class="vx-col hidden lg:block lg:w-1/2">-->
            <!--              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />-->
            <!--            </div>-->
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"
              style="border: 1px solid lightgrey; max-width: 400px"
            >
              <div class="p-8">
                <!--                <div class="vx-card__title mb-8">-->
                <!--<h4 class="mb-4">Welcome</h4>-->
                <!--                  <p>{{ !this.$store.state.isSignUp ? 'Please login to manage your accounts' : 'Please enter your details'}}</p>-->
                <!--                </div>-->

                <!--<LoginWithOTP />-->

                <!--                <div v-if="this.$store.state.isSignUp">-->
                <!--                  <SignUpForm />-->
                <!--                </div>-->
                <div v-if="this.$store.state.resetPassword">
                  <ResetPassword />
                </div>
                <div v-else>
                  <div v-if="code">
                    {{
                      tokenLoginError
                        ? tokenLoginError
                        : 'Logging you in with token. Please wait.'
                    }}
                    <div ref="loginWithToken"></div>
                  </div>
                  <div v-else>
                    <LoginWithPassword />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          margin: 10px 0;
          text-align: center;
        "
      >
        <span style="align-self: center">
          Please contact us at
          <a
            href="mailto:support@triple-a.io?bcc=kohzhihao@triple-a.io&subject=Unable to login to Triple-A dashboard"
            >support@triple-a.io</a
          >
        </span>
        <span style="align-self: center"> if you have any questions. </span>
      </div>
    </div>
  </div>
</template>

<script>
//import LoginWithOTP from "../../components/triplea-login/LoginWithOTP";
import LoginWithPassword from '../../components/triplea-login/LoginWithPassword';
import ResetPassword from '../../components/triplea-login/ResetPassword';
import SignUpForm from '../../components/triplea-signup/SignUp';

export default {
  components: {
    LoginWithPassword,
    SignUpForm,
    ResetPassword,
  },
  props: ['code', 'userEmail'],
  data() {
    return {
      signUpEmail: '',
      tokenLoginError: '',
    };
  },
  async mounted() {
    const url = new URL(window.location);
    const signUpEmail = url.searchParams.get('signup_email');
    if (signUpEmail) {
      this.signUpEmail = signUpEmail;
    }
    if (this.code) {
      this.signInWithToken();
    } else if (this.$store.state.activeUser !== null) {
      this.$router.push('/add-account');
    }
  },
  methods: {
    signUp() {
      this.$store.commit('GO_TO_SIGN_UP', !this.$store.state.isSignUp);
    },

    async signInWithToken() {
      this.$vs.loading({
        container: this.$refs.loginWithToken.$el,
        scale: 0.45,
      });
      this.getTokenWithCode(this.code)
        .then((res) => {
          if (this.$store.state.activeUser) {
            this.$store.state.activeUser.userToken = res.data.access_token;
          } else {
            this.$store.state.activeUser = { userToken: res.data.access_token };
          }
          this.apiGetUserProfile().then(
            (profileData) => {
              const userAccount = {
                firstName: profileData.firstName || '',
                lastName: profileData.lastName || '',
                country: profileData.country || '',
                mobile: profileData.mobile || '',
                email: profileData.email || '',
              };

              this.$store.commit('LOGIN_USER_ACCOUNT', userAccount);
              this.getLinkedMerchants();
            },
            (error) => {
              if (this.debugConsole) console.warn(error);
              this.loginError = true;
            }
          );
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loginWithToken.$el);
          this.tokenLoginError =
            'Issue while loging in with token : ' +
            e.message +
            '. Please retry from Backoffice';
        });
    },

    getLinkedMerchants() {
      this.apiGetMerchants().then((merchants) => {
        this.$store
          .dispatch('getCurrentActiveEntityAdminProfile')
          .then((currentEntityAdmin) => {
            const isAllowed = this.isUserAnAdmin(currentEntityAdmin.data);
            this.$store.commit('UPDATE_IS_ADMIN', isAllowed);
            this.apiGetAccounts()
              .then(() => {
                this.$vs.loading.close(this.$refs.loginWithToken.$el);
                if (
                  this.$store.state.accounts &&
                  this.$store.state.accounts.length > 0
                ) {
                  // get merchants directly linked
                  const merchantsDirectLink = Object.values(
                    currentEntityAdmin.data.merchants
                  );
                  //get merchants under partner
                  const partners = Object.values(
                    currentEntityAdmin.data.partners
                  );
                  const merchantsUnderPartner = [];
                  for (let item of partners) {
                    for (let merchant of item.merchants) {
                      merchantsUnderPartner.push(merchant);
                    }
                  }
                  const merchantsFromCurrentEntityAdminData = [
                    ...merchantsDirectLink,
                    ...merchantsUnderPartner,
                  ].sort((a, b) => a.name > b.name);
                  for (let item of merchantsFromCurrentEntityAdminData) {
                    if (
                      (item.group && Object.keys(item.group).length > 0) ||
                      (!item.group && item.id)
                    ) {
                      const findDefaultMerchant = merchants.data.find(
                        (merchant) => merchant.id === item.id
                      );
                      const merchantAccounts = findDefaultMerchant.accounts;
                      const defaultAccount =
                        merchantAccounts &&
                        merchantAccounts.find(
                          (element) =>
                            element.api_id.indexOf('_t') < 0 &&
                            element.crypto_currency === 'BTC'
                        );
                      if (defaultAccount) {
                        this.$store.commit(
                          'SET_ACTIVE_ACCOUNT',
                          defaultAccount.api_id
                        );
                      } else {
                        // Has at least 1 account and if no main account exists in the accounts
                        this.$store.commit(
                          'SET_ACTIVE_ACCOUNT',
                          merchantAccounts[0].api_id
                        );
                      }
                      this.$router.push('/home');
                      return;
                    }
                  }
                }
              })
              .catch((e) => {
                this.$vs.loading.close(this.$refs.loginWithToken.$el);
                this.tokenLoginError =
                  'Issue while loging in with token : ' +
                  e.message +
                  '. Please retry from Backoffice';
              });
          });

        this.$store.dispatch('getPermissionGroup');
      });
    },
  },
};
</script>

<style lang="scss">
.logo {
  a {
    display: inline-block;
    margin: auto auto 50px;
  }

  img {
    display: inline-block;
    width: 300px;
  }
}

.signUp {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.signUpEmailMsg {
  display: flex;
  justify-content: center;
  background-color: #4d9780;
  padding: 10px;
  align-items: center;
  color: white;
  margin: 15px 0;
  border-radius: 5px;
}

.signUpBtn {
  margin: 15px 0;
}

.vx-card {
  width: 100%;
  border-radius: 0.5rem;
  display: block;
  position: relative;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>
